import { createContext, useContext } from 'react'

export const config = {
  env: process.env.NEXT_PUBLIC_NODE_ENV,
  isDev: process.env.NEXT_PUBLIC_NODE_ENV === 'development',
  isProd: process.env.NEXT_PUBLIC_NODE_ENV === 'production',
  isStage: process.env.NEXT_PUBLIC_NODE_ENV === 'stage',
  isLocal: process.env.IS_LOCAL === 'true',
  sentryDSN: process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN,
  fbPixelId: 309374734121432,
  ymId_ru: 78854598,
  ymId_io: 98230953,
  jivoId: 'Q0n5AEVMFU',
  gtagId_ru: 'G-9XV57H1TPX',
  gtagId_io: 'G-QGRTXZ7C1W',
  rtb: 'R-A-2356180-1',
  // cookiesDomain: `.plandi.${locale}`,
  cookiesDomain: '.plandi.io',
  apiURL: process.env.API_URL,
  branch: process.env.BRANCH,
  commitHash: process.env.COMMITHASH,
  buildDate: process.env.BUILD_DATE
} as const

const configContext = createContext(config)

export const useConfig = () => useContext(configContext)

// const prodAuthUrls = (locale: string) => {
//   return {
//     signIn: `https://auth.plandi.${locale === 'ru' ? 'ru' : 'io'}/sign_in`,
//     signUp: `https://auth.plandi.${locale === 'ru' ? 'ru' : 'io'}/sign_up`
//   }
// }

// const devAuthUrls = (locale: string) => {
//   return {
//     signIn: `https://dev-auth.plandi.${locale === 'ru' ? 'ru' : 'io'}/sign_in`,
//     signUp: `https://dev-auth.plandi.${locale === 'ru' ? 'ru' : 'io'}/sign_up`
//   }
// }

// const stageAuthUrls = (locale: string) => {
//   return {
//     signIn: `https://stage-auth.plandi.${
//       locale === 'ru' ? 'ru' : 'io'
//     }/sign_in`,
//     signUp: `https://stage-auth.plandi.${locale === 'ru' ? 'ru' : 'io'}/sign_up`
//   }
// }

const prodAuthUrls = (locale: string) => {
  return {
    signIn: `https://auth.plandi.io${locale === 'en' ? '' : '/ru'}/sign_in`,
    signUp: `https://auth.plandi.io${locale === 'en' ? '' : '/ru'}/sign_up`
  }
}

const devAuthUrls = (locale: string) => {
  return {
    signIn: `https://dev-auth.plandi.io${locale === 'en' ? '' : '/ru'}/sign_in`,
    signUp: `https://dev-auth.plandi.io${locale === 'en' ? '' : '/ru'}/sign_up`
  }
}

const stageAuthUrls = (locale: string) => {
  return {
    signIn: `https://stage-auth.plandi.io${
      locale === 'en' ? '' : '/ru'
    }/sign_in`,
    signUp: `https://stage-auth.plandi.io${
      locale === 'en' ? '' : '/ru'
    }/sign_up`
  }
}

export const authUrls = config.isDev
  ? devAuthUrls
  : config.isStage
  ? stageAuthUrls
  : prodAuthUrls
